/**
 * @param {String} key
 * @param {String} value
 * @param {Any} initial
 */
export function setLocalStorage(key, value, initial) {
  try {
    if (typeof value === "object") {
      return localStorage.setItem(key, JSON.stringify(value));
    }
    return localStorage.setItem(key, value);
  } catch (error) {
    return initial;
  }
}

/**
 * @param {String} key
 * @param {Any} initial
 * @param {Boolean} json
 */
export function getLocalStorage(key, initial, json = false) {
  try {
    const storage = localStorage.getItem(key);
    if (json) {
      return JSON.parse(storage);
    }
    return storage;
  } catch (error) {
    return initial;
  }
}
